import { datadogRum } from '@datadog/browser-rum';

import useGetUserSession from './useGetUserSession';
import usePayload from './usePayload';

const useHandleDatadog = () => {
  const { userId } = useGetUserSession();
  const { consumerID, linkedAccountId, payload } = usePayload();

  const { externalId, membershipNumber } = payload ?? {};

  const datadogDeps = [externalId, linkedAccountId, membershipNumber, userId];

  const handleDatadogUser = () => {
    if (!datadogDeps.every(Boolean)) return;

    datadogRum.setUser({
      consumerID,
      externalID: externalId,
      id: userId,
      linkedAccountId,
      membershipNumber,
    });
  };

  return {
    datadogDeps,
    handleDatadogUser,
  };
};

export default useHandleDatadog;
